/*eslint-disable */
import React, { FC, useState, useContext } from "react";
import { createUseStyles, useTheme } from "react-jss";

import styles from "./styles";
import ArrowBack from "Assets/images/arrow_back.svg";
import Info from "Assets/images/info_blue.svg";
import Close from "Assets/images/modal_close.svg";
import Navigate from "Assets/images/navigation_caret.svg";
import clsx from "clsx";
import { motion } from "framer-motion";
import ShareMenuContainer from "Containers/ShareMenu";
import { MapContext } from "Context/MapContext";

interface Props {
  media: any[];
  selectedIdx: number;
  changeDisplay: (val: any) => void;
  handleMediaClick: any;
}

const PhotoviewerSmallViewPort: FC<Props> = (props: Props) => {
  const { media, selectedIdx, changeDisplay } = props;
  const useStyles = createUseStyles(styles);
  const { instId, locId } = useContext(MapContext);

  const shareUrl = `${process.env.REACT_APP_API_BASE_URL}tour/photos/${instId}/${locId}?id=${media[selectedIdx]?.id}`;

  const [description, setDescription] = useState(false);
  const [open, setIsOpen] = useState(true);

  const theme = useTheme();

  const classes = useStyles({ theme, ...props, state: { description } });

  const animations = {
    open: {
      x: "0%",
      transition: {
        ease: [0.28, 0.57, 0.2, 1],
        duration: 0.5,
      },
    },
    closed: {
      x: "-100%",
      transition: {
        ease: "easeIn",
        duration: 0.25,
        onComplete: () => {
          changeDisplay(false);
        },
      },
    },
    imageIn: {
      x: "0%",
      scale: 1,
      transition: {
        ease: [0.28, 0.57, 0.2, 1],
        duration: 0.5,
      },
    },
    imageOut: {
      x: "-100%",
      scale: 0,
      transition: {
        ease: "easeIn",
        duration: 0.5,
      },
    },
  };

  return (
    <>
      <motion.div
        initial={"closed"}
        variants={animations}
        animate={open ? "open" : "closed"}
        className={classes.viewer}
        data-testid="photo-viewer"
      >
        <div className={classes.topContainer}>
          <ArrowBack
            onClick={(e: any) => {
              e.stopPropagation();
              setIsOpen(false);
            }}
          />

          {media[selectedIdx].description && (
            <Info
              onClick={(e: any) => {
                e.stopPropagation();
                setDescription(true);
              }}
              data-testid="info"
            />
          )}
        </div>
        <div className={classes.imgContainer} data-testid="photo">
          <motion.img
            initial={"imageOut"}
            variants={animations}
            animate={open ? "imageIn" : "imageOut"}
            src={media[selectedIdx].mediumurl}
            key={media[selectedIdx].mediumurl}
            alt={media[selectedIdx].title}
            tabIndex={0}
            style={{ maxHeight: "100%", width: "100%", objectFit: "cover" }}
          ></motion.img>
        </div>
        <div className={classes.imgTitle} data-testid="title">
            {media[selectedIdx].title}
        </div>

        <div className={classes.navigate}>
          <div
            className={classes.caret}
            onClick={(e) => {
              e.stopPropagation();
              props.handleMediaClick(selectedIdx - 1);
            }}
          >
            {selectedIdx > 0 && <Navigate />}
          </div>

          <div className={classes.counter}>
            {selectedIdx + 1}/{media.length}
          </div>

          <div
            className={clsx(classes.caret, classes.rotate)}
            onClick={(e) => {
              e.stopPropagation();
              props.handleMediaClick(selectedIdx + 1);
            }}
          >
            {selectedIdx !== media.length - 1 && <Navigate />}
          </div>
        </div>

        {description && (
          <div className={classes.description} data-testid="description">
            <div className={classes.closeIcon}>
              <Close
                onClick={(e: any) => {
                  e.stopPropagation();
                  setDescription(false);
                }}
              />
            </div>
            <div
              className={classes.descriptionText}
              dangerouslySetInnerHTML={{
                __html:
                  media[selectedIdx].description || media[selectedIdx].title,
              }}
            ></div>
          </div>
        )}
        <div>
          <span
            style={{
              cursor: "pointer",
              position: "fixed",
              bottom: "0%",
              right: "5%",
            }}
          >
            <ShareMenuContainer url={shareUrl} svgColor="#FFFFFF" />
          </span>
        </div>
      </motion.div>
    </>
  );
};

export default PhotoviewerSmallViewPort;
